{
  "模仿学习：示范多少才够 · 物理AI实验室 Lab 1.6": {
    "en": "Imitation learning: how many demos are enough · Physical AI Lab 1.6",
    "ja": "模倣学習：お手本はいくつあれば足りるか · Physical AI Lab 1.6"
  },
  "示范多少条才够？": {
    "en": "How many demos?",
    "ja": "お手本はいくつあれば足りる？"
  },
  "让机械臂照着示范学把杯子放进盒子。示范条数一样多，杯子位置<span style=\"color:var(--see)\">各不相同</span>和<span style=\"color:var(--think)\">总在同一处</span>，学出来差很多。": {
    "en": "Learning to put a cup in a box from demos. Same count, but a cup <span style=\"color:var(--see)\">placed anywhere</span> vs <span style=\"color:var(--think)\">always in one spot</span>: very different results.",
    "ja": "お手本を見て、カップを箱に入れることを学ぶ。本数が同じでも、カップが<span style=\"color:var(--see)\">毎回違う所</span>か<span style=\"color:var(--think)\">いつも同じ所</span>かで、結果は大違い。"
  },
  "成功率 vs 示范条数（横轴对数）": {
    "en": "Success rate vs demos (log x)",
    "ja": "成功率 vs お手本の本数（横軸は対数）"
  },
  "10 条示范": {
    "en": "10 demos",
    "ja": "お手本 10 本"
  },
  "{0} 条示范": {
    "en": "{0} demos",
    "ja": "お手本 {0} 本"
  },
  "各不相同": {
    "en": "Varied",
    "ja": "毎回違う"
  },
  "总在同一处": {
    "en": "One spot",
    "ja": "いつも同じ所"
  },
  "点：单次训练 · 线：5 次平均 · 带：5 次的范围": {
    "en": "dot: one run · line: mean of 5 · band: range of 5",
    "ja": "点：1回の学習 · 線：5回の平均 · 帯：5回の範囲"
  },
  "5 次训练：{0}–{1} / 50": {
    "en": "5 runs: {0}–{1} / 50",
    "ja": "学習5回：{0}–{1} / 50"
  },
  "每个点训练 5 次（换示范、换初始化），每次都在同样 50 个起始位置上评测。单次训练的结果会差很多，所以只看一次训练不可靠。": {
    "en": "Each point is trained 5 times (new demos, new initialisation), each scored on the same 50 start positions. Single runs vary a lot, so one run alone can't be trusted.",
    "ja": "各点は5回学習し（お手本と初期値を変えて）、毎回同じ 50 の開始位置で評価します。1回ごとの結果は大きくばらつくので、1回だけでは信用できません。"
  },
  "示范条数": {
    "en": "Demos",
    "ja": "お手本の本数"
  },
  "场景多样（杯子位置各不相同）": {
    "en": "Varied scenes (cup in a different place each time)",
    "ja": "場面を多様に（カップの位置が毎回違う）"
  },
  "回放：10 条、同一处": {
    "en": "Replay: 10, one spot",
    "ja": "再生：10 本・同じ所"
  },
  "回放：100 条、各不相同": {
    "en": "Replay: 100, varied",
    "ja": "再生：100 本・毎回違う"
  },
  "回放 · 评测起点": {
    "en": "Replay · eval start",
    "ja": "再生 · 評価の開始位置"
  },
  "10 条示范，杯子总在同一处": {
    "en": "10 demos, cup always in one spot",
    "ja": "お手本 10 本、カップはいつも同じ所"
  },
  "100 条示范，杯子位置各不相同": {
    "en": "100 demos, cup in varied spots",
    "ja": "お手本 100 本、カップの位置は毎回違う"
  },
  "第 {0} s · 夹爪 x {1} m · 杯子高 {2} cm": {
    "en": "t {0} s · gripper x {1} m · cup height {2} cm",
    "ja": "{0} s · グリッパー x {1} m · カップの高さ {2} cm"
  },
  "拖示范条数，看曲线": {
    "en": "drag the demo count, watch the curve",
    "ja": "お手本の本数を動かして曲線を見る"
  },
  "放进盒子": {
    "en": "IN THE BOX",
    "ja": "箱に入った"
  },
  "一路直达，没有停顿": {
    "en": "straight there, no pause",
    "ja": "止まらずまっすぐ"
  },
  "中途跑偏": {
    "en": "LOST ON THE WAY",
    "ja": "途中でずれた"
  },
  "抓起来了，却停在半路，杯子慢慢滑落": {
    "en": "picked it up, stalled halfway, the cup slowly slips out",
    "ja": "持ち上げたが途中で止まり、カップがゆっくり滑り落ちる"
  },
  "抓取中": {
    "en": "GRASPING",
    "ja": "把持中"
  },
  "回放记录下的评测回合": {
    "en": "replaying a recorded evaluation episode",
    "ja": "記録した評価エピソードを再生"
  },
  "数据：L5 毕业项目（MuJoCo {0}，{1}）· 行为克隆 2×64 · 每点 5 次训练 × 50 个起始位置": {
    "en": "Data: L5 capstone (MuJoCo {0}, {1}) · behaviour cloning 2×64 · 5 runs × 50 start positions per point",
    "ja": "データ：L5 修了プロジェクト（MuJoCo {0}、{1}）· 行動クローニング 2×64 · 各点 学習5回 × 開始位置 50"
  },
  "拖示范条数 · 切场景多样性 · 拖动空白处旋转视角": {
    "en": "Drag the demo count · toggle scene variety · drag empty space to orbit",
    "ja": "お手本の本数をドラッグ · 場面の多様さを切り替え · 空いた所をドラッグして視点を回す"
  }
}
